import React, { useState } from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import BasicDrawer from "@components/drawer/BasicDrawer";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";

const Container = styled.div(({ theme }) => ({
  display: "Flex",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "2rem",
  background: "white",

  ".count": {
    fontWeight: theme.fontWeight.medium,
    lineHeight: "1.6rem",
    color: theme.color.gray,
  },
}));

const FilterItem = styled.button<{ isLast: boolean; focus: boolean }>(
  ({ theme, isLast, focus }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.4rem",
    fontSize: "1.6rem",
    fontWeight: theme.fontWeight.medium,
    color: focus ? theme.color.green : theme.color.black,
    lieneHeight: "1.6rem",
    cursor: "pointer",
    padding: "2rem 0",
    borderBottom: isLast ? "none" : `1px solid ${theme.color.border_gray}`,
  }),
);

const FilterButton = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  lineHeight: "1.6rem",
  gap: "0.4rem",
  fontWeight: theme.fontWeight.medium,
}));

type Props = {
  totalCount: number;
  filterList?: any[];
  onSortChange?: (value: string) => void;
};

const ProductListFilter = ({ totalCount, filterList, onSortChange }: Props) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const theme = useTheme();
  const lang = window.localStorage.getItem("language");
  const [selectedFilter, setSelectedFilter] = useState(
    filterList?.[0]?.code || "DATE_DESC",
  );
  const { t } = useTranslation();

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  return (
    <Container>
      <span className="count">
        {t("총")} {totalCount} {t("건")}
      </span>

      <FilterButton onClick={handleOpenDrawer} className="filter">
        <span>
          {lang === "en"
            ? filterList?.find((f) => f.code === selectedFilter)?.name_en
            : filterList?.find((f) => f.code === selectedFilter)?.name_ko}
        </span>
        <Image src={theme.image.arrow_down.default} size="1.6rem" />
      </FilterButton>

      <BasicDrawer open={openDrawer} setOpen={setOpenDrawer}>
        {filterList?.map((filter, index) => (
          <FilterItem
            focus={filter.code === selectedFilter}
            isLast={index === filterList.length - 1}
            key={filter.code}
            onClick={() => {
              setSelectedFilter(filter.code);
              // 상위 컴포넌트에 정렬 변경 알림
              onSortChange?.(filter.code);
              setOpenDrawer(false);
            }}>
            <span>{lang === "en" ? filter.name_en : filter.name_ko}</span>
            {filter.code === selectedFilter && (
              <Image src={theme.image.check_green.default} />
            )}
          </FilterItem>
        ))}
      </BasicDrawer>
    </Container>
  );
};

export default ProductListFilter;
